import { createSlice } from "@reduxjs/toolkit";
import { getActivityUsers } from "./thunk";

export const initialState = {
  activityData: [],
  loading: false,
  error: null,
};

const UserSlice = createSlice({
  name: "UserSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActivityUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityUsers.fulfilled, (state, action) => {
        state.activityData = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getActivityUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default UserSlice.reducer;
